// import React from 'react';


// import AboutUs from './components/AboutUs';
// import AdminDashboard from './components/AdminDashboard';
// import AdminSlider from './components/AdminSlider';
// import Homepage from './components/Homepage';
// import MediaUploader from './components/MediaUploader';
// import Gallery from './components/Gallery';
// import Slider from './components/Slider';
// import AcademicAdminDashboard from './components/AcademicAdminDashboard';
// import AcademicStudentView from './components/AcademicStudentView';
// import AddParentForm from './components/AddParentForm';
// import CBSEDisclosures from './components/CBSEDisclosures';
// import Facilities from './components/Facilities';
// import AdminLogin from './components/AdminLogin';
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
// } from 'react-router-dom';


// function App() {
//   return (

// <Router>
//   <Routes>
//     <Route path="/" element={<Homepage />} />
//     <Route path="/about-school" element={<AboutUs />} />
//     <Route path="/Gallery" element={<Gallery />} />
//     <Route path="/Slider" element={<Slider />} />
//     <Route path="/AcademicStudentView" element={<AcademicStudentView />} />
//     <Route path="/CBSEDisclosures" element={<CBSEDisclosures />} />
//     <Route path="/Facilities" element={<Facilities />} />
//     <Route path="/AdminLogin" element={<AdminLogin />} />
//     {/* Add more routes as needed */}

//    <Route path="/AdminDashboard" element={<AdminDashboard />} />
//     <Route path="/MediaUploader" element={<MediaUploader />} />
//     <Route path="/AcademicAdminDashboard" element={<AcademicAdminDashboard />} />
//      <Route path="/AddParentForm" element={<AddParentForm />} />
//     <Route path="/AdminSlider" element={<AdminSlider />} />

//   </Routes>
// </Router>

//   );
// }

// export default App;



// import React from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import AboutUs from './components/AboutUs';
// import AdminDashboard from './components/AdminDashboard';
// import AdminSlider from './components/AdminSlider';
// import Homepage from './components/Homepage';
// import MediaUploader from './components/MediaUploader';
// import Gallery from './components/Gallery';
// import Slider from './components/Slider';
// import AcademicAdminDashboard from './components/AcademicAdminDashboard';
// import AcademicStudentView from './components/AcademicStudentView';
// import AddParentForm from './components/AddParentForm';
// import CBSEDisclosures from './components/CBSEDisclosures';
// import Facilities from './components/Facilities';
// import AdminLogin from './components/AdminLogin';

// // Protected Route Component
// const ProtectedRoute = ({ children }) => {
//   const isAuthenticated = localStorage.getItem('adminToken'); // Check if admin is logged in
  
//   if (!isAuthenticated) {
//     // If not authenticated, redirect to login page
//     return <Navigate to="/AdminLogin" replace />;
//   }
  
//   // If authenticated, render the child components
//   return children;
// };

// function App() {
//   return (
//     <Router>
//       <Routes>
//         {/* Public Routes */}
        // <Route path="/" element={<Homepage />} />
        // <Route path="/about-school" element={<AboutUs />} />
        // <Route path="/Gallery" element={<Gallery />} />
        // <Route path="/Slider" element={<Slider />} />
        // <Route path="/AcademicStudentView" element={<AcademicStudentView />} />
        // <Route path="/CBSEDisclosures" element={<CBSEDisclosures />} />
        // <Route path="/Facilities" element={<Facilities />} />
        // <Route path="/AdminLogin" element={<AdminLogin />} />
        
//         {/* Protected Admin Routes */}
      //   <Route 
      //     path="/AdminDashboard" 
      //     element={
      //       <ProtectedRoute>
      //         <AdminDashboard />
      //       </ProtectedRoute>
      //     } 
      //   />
      //   <Route 
      //     path="/MediaUploader" 
      //     element={
      //       <ProtectedRoute>
      //         <MediaUploader />
      //       </ProtectedRoute>
      //     } 
      //   />
      //   <Route 
      //     path="/AcademicAdminDashboard" 
      //     element={
      //       <ProtectedRoute>
      //         <AcademicAdminDashboard />
      //       </ProtectedRoute>
      //     } 
      //   />
      //   <Route 
      //     path="/AddParentForm" 
      //     element={
      //       <ProtectedRoute>
      //         <AddParentForm />
      //       </ProtectedRoute>
      //     } 
      //   />
      //   <Route 
      //     path="/AdminSlider" 
      //     element={
      //       <ProtectedRoute>
      //         <AdminSlider />
      //       </ProtectedRoute>
      //     } 
      //   />
      // </Routes>
//     </Router>
//   );
// }

// export default App;









// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import ProtectedRoute from './ProtectedRoute';
import AboutUs from './components/AboutUs';
import AdminDashboard from './components/AdminDashboard';
import AdminSlider from './components/AdminSlider';
import Homepage from './components/Homepage';
import MediaUploader from './components/MediaUploader';
import Gallery from './components/Gallery';
import Slider from './components/Slider';
import AcademicAdminDashboard from './components/AcademicAdminDashboard';
import AcademicStudentView from './components/AcademicStudentView';
import AddParentForm from './components/AddParentForm';
import CBSEDisclosures from './components/CBSEDisclosures';
import Facilities from './components/Facilities';
import AdminLogin from './components/AdminLogin';
import BoardManagement from './components/BoardofManagment';
import Faculties from './components/Faculties';
import Calendar from './components/Calendar';
import Notify from './components/Notify';
import Notification from './components/Notification';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
           <Route path="/" element={<Homepage />} />
        <Route path="/about-entities" element={<AboutUs />} />
        <Route path="/Gallery" element={<Gallery />} />
        <Route path="/Slider" element={<Slider />} />
        <Route path="/AcademicStudentView" element={<AcademicStudentView />} />
        <Route path="/CBSEDisclosures" element={<CBSEDisclosures />} />
        <Route path="/Facilities" element={<Facilities />} />
        <Route path="/AdminLogin" element={<AdminLogin />} />
        <Route path="/board-of-management" element={<BoardManagement />} />
        <Route path="/faculties" element={<Faculties/>} />
        <Route path='/Calender' element={<Calendar/>} />
        <Route path="/Notify" element={<Notify />} />
          
          {/* Protected Admin Routes */}
         <Route 
          path="/AdminDashboard" 
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/MediaUploader" 
          element={
            <ProtectedRoute>
              <MediaUploader />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/AcademicAdminDashboard" 
          element={
            <ProtectedRoute>
              <AcademicAdminDashboard />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/AddParentForm" 
          element={
            <ProtectedRoute>
              <AddParentForm />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/AdminSlider" 
          element={
            <ProtectedRoute>
              <AdminSlider />
            </ProtectedRoute>
          } 

        />
        <Route 
          path="/Notification" 
          element={
            <ProtectedRoute>
              <Notification />
            </ProtectedRoute>
          } 
        />
      </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;